import BaseService from 'services/base'

export default class SharedProposalService extends BaseService {
    getSharedProposal(key) {
        return this.get(`shared/proposal/${encodeURIComponent(key)}`)
    }
}